import DateFormatter from "@/utils/DateFormatter";
import Model from "@/models/Model";

export default class Statement extends Model {

  get id() {
    return this.rownumber;
  }

  get rowNumber() {
    return this.rownumber;
  }

  get paymentYear() {
    return this.acty;
  }

  get invoiceNumber() {
    return this.sfnr;
  }

  get invoiceDate() {
    return this.fakdat;
  }

  get invoiceDateFormatted() {
    return DateFormatter.numericToISO(this.invoiceDate);
  }

  get paymentDate() {
    return this.betdat;
  }

  get paymentDateFormatted() {
    return DateFormatter.numericToISO(this.paymentDate);
  }

  get paidTo() {
    return this.binf;
  }

  get VATNumber() {
    return this.vatn;
  }

  get amountPaid() {
    return this.utbk;
  }

  get administrativeCharge() {
    return this.fadm;
  }

  get serviceVAT() {
    return this.ftjm;
  }

  // FTJMR;

  get grossAmount() {
    return this.kers;
  }

  get grossVAT() {
    return this.kkmo;
  }

  // KKMOR;

  get status() {
    return this.stat;
  }

  get netAmount() {
    return this.ners;
  }

}